import { Button } from '@repo/studio-design-system-ui-button'
import { STUDIO_APP_ROUTES } from '@repo/studio-utils/studio-app-routes'

const API_PLATFORM_LABEL = 'API'

export function ApiPlatformLink() {
  return (
    <Button
      asChild
      size="sm"
      iconOnly
      variant="secondary"
      aria-label={API_PLATFORM_LABEL}
      className="typography-11"
    >
      <a href={STUDIO_APP_ROUTES.API_PLATFORM} target="_blank" rel="noreferrer">
        {API_PLATFORM_LABEL}
      </a>
    </Button>
  )
}
